/**
 * Tras una suscripción Mercado Pago (brick), mismo gate que Stripe membership:
 * embudo en `MEMBERSHIP_ROUTE` (registro → completar → pendiente → mi acceso).
 *
 * Stripe fuerza `/registro` en `/api/create-subscription-checkout` para los mismos
 * `plan_tier` de membresía (véase `planTierUsesClerkRegistro`).
 */

import { MEMBERSHIP_ROUTE } from "@/lib/membershipAccessFlow";

const MEMBERSHIP_CLERK_TIERS = new Set(["standard", "vip", "platinum", "basic", "devil"]);

/** Membresías que siempre pasan por cuenta Clerk antes del acceso. */
export function planTierUsesClerkRegistro(planTier: string): boolean {
  return MEMBERSHIP_CLERK_TIERS.has(planTier.trim().toLowerCase());
}

/** @deprecated Usar `planTierUsesClerkRegistro` */
export function planTierRequiresRegistroPendingApproval(planTier: string): boolean {
  return planTierUsesClerkRegistro(planTier);
}

/**
 * URL absoluta a `/registro` con query compatible con `Registro.tsx` / `CompleteRegistration.tsx`.
 */
export function buildRegistroUrlAfterMpSubscription(
  origin: string,
  subscriptionId: string,
  planTier: string,
): string {
  const base = origin.replace(/\/$/, "");
  const tier = planTier.trim().toLowerCase();
  const q = new URLSearchParams();
  q.set("from_mp", "true");
  q.set("subscription_id", subscriptionId.trim());
  if (tier) q.set("plan_tier", tier);
  if (tier === "vip" || tier === "platinum" || tier === "devil") q.set("from_vip", "1");
  else if (tier === "basic") q.set("from_basic", "1");
  else if (tier === "standard") q.set("from_standard", "1");
  return `${base}${MEMBERSHIP_ROUTE.PORTAL_REGISTRO}?${q.toString()}`;
}
